import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconNextArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 18,
	viewBox: "0 0 28 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.387 1.06518L26.5065 8.13704C27.168 8.523 27.1679 9.47876 26.5064 9.86457L14.3863 16.9333C13.8819 17.2275 13.3684 16.566 13.7784 16.1503L19.445 10.405C19.5675 10.2807 19.6705 10.1445 19.754 10L1.99707 10C1.44479 10 0.99707 9.55229 0.99707 9C0.99707 8.44772 1.44479 8 1.99707 8L19.7533 8C19.6701 7.85611 19.5674 7.72037 19.4454 7.59655L13.7789 1.84804C13.369 1.43221 13.8827 0.770911 14.387 1.06518Z",
		fill: "#004899"
	})
});
export default SvgIconNextArrow;
